const ITEMS = [
  "International Trade Consulting",
  "Market-Entry Strategy",
  "Buyer & Supplier Sourcing",
  "Business Partnerships",
  "Trade Representation",
  "Import-Export Advisory",
];

export const Marquee = () => (
  <div className="relative overflow-hidden border-y border-gold/15 bg-royal py-6" data-testid="editorial-marquee">
    <div className="animate-marquee flex w-max">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center" aria-hidden={dup === 1}>
          {ITEMS.map((item) => (
            <span key={`${item}-${dup}`} className="flex items-center">
              <span className="mx-10 whitespace-nowrap font-serif text-lg tracking-[0.12em] text-slate-400 sm:text-xl">
                {item}
              </span>
              <span className="text-[10px] text-gold">◆</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
